import { createSlice } from "@reduxjs/toolkit";

const contentCopywritingPaginationSlice = createSlice({
  name: "contentCopywritingPagination",
  initialState: {},

  reducers: {
    setContentCopywritingPagination: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default contentCopywritingPaginationSlice;
